module.exports = __webpack_public_path__ + "static/media/arm-right-front.efc1e762.png";